import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 20a8 8 0 100-16 8 8 0 000 16zm-2-12v5l1 1h4v-2h-3V8h-2z" }));
export default createSvgIcon(iconPath, "In review");
//# sourceMappingURL=StatusInReviewIcon.js.map